/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_OrInputs */



/**
* | output |
* | --- |
* | "or" |
*
* @param {Common_OrInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const common_or = /** @type {((inputs?: Common_OrInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_OrInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("ou")
	if (locale === "es") return /** @type {LocalizedString} */ ("o")
	if (locale === "pt") return /** @type {LocalizedString} */ ("ou")
	if (locale === "it") return /** @type {LocalizedString} */ ("oppure")
	return /** @type {LocalizedString} */ ("or")
});